import { FC, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { t } from "i18next";

import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import {
  faCommand,
  faDumbbell,
  faPersonRays,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useWeightQuery } from "@/app/weights/weights";

import TableListExercisesWeekDescription from "@/shared/components/organisms/TableListExercisesWeekDescription";
import { ModalDescriptionExercise } from "@/shared/components/organisms/ModalDescriptionExercise";
import { ModalDescriptionPlan } from "@/shared/components/organisms/ModalDescriptionPlan";
import { InputWithCornerHint } from "@/shared/components/atoms/InputWithCornerHint";
import { ButtonFullSecondary } from "@/shared/components/atoms/ButtonFullSecondary";
import { ModalPlans } from "@/shared/components/organisms/ModalTrainingPlan";
import { DialogCreate } from "@/shared/components/molecules/DialogCreate";
import TableListPlan from "@/shared/components/organisms/TableListPlan";
import { InputsCard } from "@/shared/components/organisms/InputsCard";
import { InputFilepdf } from "@/shared/components/atoms/InputFilePDF";
import { Select } from "@/shared/components/organisms/Select";
import InputRadio from "@/shared/components/atoms/InputRadio";
import { TabsUser } from "@/shared/components/organisms/TabsUser";
import { Modal } from "@/shared/components/organisms/Modal";
import DialogAssignFee from "./Components/DialogAssignFee";
import { toasts } from "@/shared/utils/toasts";

import { useGetAllCountriesQuery } from "@/app/app.apiCountry";
import { usePersonalInformationQuery } from "@/app/personal-informations/personal-informations.api";
import { useFinishTrainingWizardMutation } from "@/app/training-wizard/training-wizard.api";

import { selectUser } from "@/app/auth/auth.slice";

// API
import { useEnrollLessonMutation } from "@/app/lessons/lessons.api";
import { useEnrollAssistedMutation } from "@/app/assisteds/assisteds.api";
import {
  useLazyMealOptionsQuery,
  useFinishNutritionWizardMutation,
} from "@/app/nutrition-wizard/nutrition-wizard.api";
import { useHeightQuery } from "@/app/heights/heights.api";
import { useUserGetQuery } from "@/app/users/users.api";

// Component User Content
import { UserContent } from "./Components/UserContent";

export const InformationUserPages: FC<any> = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const user = useSelector(selectUser);
  console.log("HEREEEEE");

  const [userInfo, setUserInfo] = useState(null);

  const userQuery = useUserGetQuery({ id });

  useEffect(() => {
    if (userQuery.data) {
      setUserInfo(userQuery.data);
    }
  }, [userQuery]);

  const [mealOptions, mealOptionsResult] = useLazyMealOptionsQuery();
  const [finishNutritionWizard, finishNutritionWizardResult] =
    useFinishNutritionWizardMutation();
  const [finishTrainingWizard, finishTrainingWizardResult] =
    useFinishTrainingWizardMutation();
  const personalInformationQuery = usePersonalInformationQuery({
    userId: id,
    status: 1,
  });

  useEffect(() => {
    if (finishTrainingWizardResult.isSuccess) {
      const params = new URLSearchParams();
      params.set("user_id", finishTrainingWizardResult.data.userId);
      params.set(
        "training_progress_id",
        finishTrainingWizardResult.data.trainingProgressId
      );
      params.set("id", finishTrainingWizardResult.data.id);
      params.set("position", finishTrainingWizardResult.data.position);
      params.set("name", finishTrainingWizardResult.data.name);

      navigate(`/training?${params.toString()}`);
    }
  }, [finishTrainingWizardResult]);

  useEffect(() => {
    if (finishNutritionWizardResult.isSuccess) {
      const params = new URLSearchParams();
      params.set("user_id", finishNutritionWizardResult.data.userId);
      params.set(
        "nutrition_progress_id",
        finishNutritionWizardResult.data.trainingProgressId
      );
      params.set("id", finishNutritionWizardResult.data.id);
      params.set("position", finishNutritionWizardResult.data.position);
      params.set("name", finishNutritionWizardResult.data.name);

      navigate(`/nutrition?${params.toString()}`);
    }
  }, [finishNutritionWizardResult]);

  const weightQuery = useWeightQuery(
    {
      personalInformationId: personalInformationQuery.data?.id,
      status: 1,
    },
    { skip: !personalInformationQuery.isSuccess }
  );

  const heightQuery = useHeightQuery(
    {
      personalInformationId: personalInformationQuery.data?.id,
      status: 1,
    },
    { skip: !personalInformationQuery.isSuccess }
  );

  //OPEN FOR DIALOG CREATE
  const [open, setOpen] = useState(false);
  const openDialog = () => setOpen(!open);
  const [formSelect, setFormSelect] = useState(0);
  const optionsBaja = [
    { id: 1, name: "Baja 1" },
    { id: 2, name: "Baja 2" },
  ];
  const [selectedBaja, setSelectedBaja] = useState(optionsBaja[0]);
  const [selectedOption, setSelectedOption] = useState("card");

  // Función para manejar el cambio del radio
  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
  };
  //SELECT DE PAIS
  const optionsPais = [
    { id: 1, name: "Spain" },
    { id: 2, name: "Andorra" },
    { id: 3, name: "Mexico" },
    { id: 4, name: "Colombia" },
  ];
  const [selectPais, setSelectPais] = useState(optionsPais[0]);
  //SELECT TYPE PAYMENT
  const optionsTypePayment = [
    { id: 1, name: t("direct_debit.views.payment_manual_1") },
    { id: 2, name: t("direct_debit.views.payment_manual_2") },
    { id: 3, name: t("direct_debit.views.payment_manual_3") },
    { id: 4, name: t("direct_debit.views.payment_manual_4") },
    { id: 5, name: t("direct_debit.views.payment_manual_5") },
  ];
  const [selectTypePayment, setSelectTypePayment] = useState(
    optionsTypePayment[0]
  );
  //SELECT HACIENDA
  const optionsHacienda = [
    { id: 1, name: t("gti.views.not_generate") },
    { id: 2, name: t("accounting.views.ticket") },
    { id: 3, name: t("gti.views.invoice") },
  ];
  const [selectHacienda, setSelectHacienda] = useState(optionsHacienda[0]);
  //SELECT TYPE ID
  const optionsTypeId = [
    { id: 1, name: t("store.views.cedula_fisica") },
    { id: 2, name: t("store.views.cedula_juridica") },
    { id: 3, name: t("store.views.dimex") },
    { id: 4, name: t("store.views.nite") },
    { id: 5, name: t("store.views.extranjera") },
  ];
  const [selectTypeId, setSelectTypeId] = useState(optionsTypeId[0]);

  const [openDialogAsingFee, setOpenDialogAsingFee] = useState(false);
  const handleOpenDialogAsingFee = (id: number) => {
    setOpenDialogAsingFee(!openDialogAsingFee);
  };

  const [openDialogAsingAssisteds, setOpenDialogAsingAssisteds] =
    useState(false);

  const handleOpenDialogAsingAssisteds = (lesson) => {
    setLesson(lesson);
    setOpenDialogAsingAssisteds(!openDialogAsingAssisteds);
  };

  const [openDialogAsingLessons, setOpenDialogAsingLessons] = useState(false);

  const handleOpenDialogAsingLessons = (lesson) => {
    setLesson(lesson);
    setOpenDialogAsingLessons(!openDialogAsingLessons);
  };

  const optionsMatricula = [
    { id: 1, name: "Sin Matricula" },
    { id: 2, name: "Matricula 1" },
    { id: 3, name: "Matricula 2" },
  ];
  const [matricula, setMatricula] = useState(optionsMatricula[0]);

  const [openDialogAssingBond, setOpenDialogAssingBond] = useState(false);
  const handleOpenDialogAssingBond = () =>
    setOpenDialogAssingBond(!openDialogAssingBond);

  const [selectedOptionBond, setSelectedOptionBond] = useState("cash");

  // Función para manejar el cambio del radio
  const handleRadioChangeBond = (event) => {
    setSelectedOptionBond(event.target.value);
  };

  const [openDialogEditBond, setOpenDialogEditBond] = useState(false);
  const handleOpenDialogEditBond = () =>
    setOpenDialogEditBond(!openDialogEditBond);

  const [openDialogCourses, setOpenDialogCourses] = useState(false);
  const handleOpenDialogCourses = () =>
    setOpenDialogCourses(!openDialogCourses);
  const [formsCourses, setFormsCourses] = useState(0);

  const [openDialogBondsSP, setOpenDialogBondsSP] = useState(false);
  const handleOpenDialogBondsSP = () =>
    setOpenDialogBondsSP(!openDialogBondsSP);
  const [titleDialogSP, setTitleDialogSP] = useState("");
  const [textButtonSubmitSP, setTextButtonSubmitSP] = useState("");
  const [formSp, setFormSp] = useState(0);

  const [openDialogFeeCursos, setOpenDialogFeeCursos] = useState(false);
  const handleOpenDialogFeeCursos = () =>
    setOpenDialogFeeCursos(!openDialogFeeCursos);
  const [titleDialogFeeCursos, setTitleDialogFeeCursos] = useState("");
  const [formFeeCursos, setFormFeeCursos] = useState(0);

  const OptionsBrandedActiveFeeCursos = [
    {
      id: 1,
      title: t("fees.views.button_pay"),
      description: "Generar Pago",
      function: () => {
        handleOpenDialogRenewFeeCR();
      },
    },
    {
      id: 2,
      title: t("fees.views.button_low"),
      description: "Dar de baja",
      function: () => {
        handleOpenDialogFeeCursos();
        setTitleDialogFeeCursos(t("fees.views.title_modal_confirm_low"));
        setFormFeeCursos(1);
      },
    },
    {
      id: 3,
      title: t("fees.views.cancel"),
      description: "Anular",
      function: () => {
        handleOpenDialogFeeCursos();
        setTitleDialogFeeCursos(t("fees.views.cancel"));
        setFormFeeCursos(2);
      },
    },
    {
      id: 4,
      title: t("user.views.desactive_recurrency"),
      description: "Desactivar recurrencia",
      function: () => {
        handleOpenDialogFeeCursos();
        setTitleDialogFeeCursos(t("user.views.desactive_recurrency"));
        setFormFeeCursos(3);
      },
    },
  ];

  const [openDialogRenewFeeCR, setOpenDialogRenewFeeCR] = useState(false);
  const handleOpenDialogRenewFeeCR = () =>
    setOpenDialogRenewFeeCR(!openDialogRenewFeeCR);

  const [openMethodsPay, setOpenMethodsPay] = useState(false);
  const handleOpenMethodsPay = () => setOpenMethodsPay(!openMethodsPay);
  const [titleDialogMethodsPay, setTitleDialogMethodsPay] = useState("");
  const optionsMethodsPay = [
    {
      id: 1,
      name: "Domiciliación bancaria manual",
      description: "ES0700120345030000067890",
    },
    {
      id: 2,
      name: "Efectivo",
      description: "Datafono",
    },
  ];

  const [openNutritionFile, setOpenNutritionFile] = useState(false);
  const handleOpenNutritionFile = () =>
    setOpenNutritionFile(!openNutritionFile);

  const archiveNutritionFile = [{ id: 1, name: "PDFNUTRITION.pdf" }];

  const [openModalTrainingPlan, setOpenModalTrainingPlan] = useState(false);
  const handleOpenModalTrainingPlan = () =>
    setOpenModalTrainingPlan(!openModalTrainingPlan);

  const trainings = [
    {
      id: 1,
      name: "Plan de entrenamiento",
      objective: "Bajar de Peso",
      weeks: "1 Semana",
      days: "1",
    },
    {
      id: 2,
      name: "Plan de nutrición",
      objective: "Ganar Masa Muscular",
      weeks: "4 Semanas",
      days: "5",
    },
    {
      id: 3,
      name: "Entrenamiento de fuerza",
      objective: "Incrementar Fuerza",
      weeks: "6 Semanas",
      days: "3",
    },
    {
      id: 4,
      name: "Rutina HIIT",
      objective: "Mejorar Condición Física",
      weeks: "2 Semanas",
      days: "4",
    },
    {
      id: 5,
      name: "Yoga para principiantes",
      objective: "Aumentar Flexibilidad",
      weeks: "3 Semanas",
      days: "2",
    },
    {
      id: 6,
      name: "Plan de cardio",
      objective: "Mejorar Resistencia",
      weeks: "5 Semanas",
      days: "6",
    },
  ];

  const OptionsBrandedActiveSP = [
    {
      id: 1,
      title: t("bond.views.assign"),
      description: "Asignar Bono",
      function: () => {
        handleOpenDialogAssingBond();
      },
    },
    {
      id: 2,
      title: t("share.views.edit"),
      description: "Modificar cantidad de sesiones",
      function: (bond: any) => {
        handleOpenDialogBondsSP();
        setTitleDialogSP(t("user.views.update_bond_user"));
        setTextButtonSubmitSP(t("general.save"));
        setFormSp(1);
      },
    },
    {
      id: 3,
      title: t("share.views.transfer"),
      description: "Transferir bonos",
      function: () => {
        handleOpenDialogBondsSP();
        setTitleDialogSP(t("user.views.transfer_bond"));
        setTextButtonSubmitSP(t("share.views.transfer"));
        setFormSp(2);
      },
    },
  ];

  const [openNewPlanNutrition, setOpenNewPlanNutrition] = useState(false);
  const handleOpenNewPlanNutrition = () =>
    setOpenNewPlanNutrition(!openNewPlanNutrition);

  const [openModalNutritionPlan, setOpenModalNutritionPlan] = useState(false);
  const handleOpenModalNutritionPlan = () =>
    setOpenModalNutritionPlan(!openModalNutritionPlan);

  const nutritions = [
    {
      id: 1,
      name: "Plan de Pollo",
      objective: "Bajar de Peso",
      weeks: "1 Semana",
    },
    {
      id: 2,
      name: "Plan de Pollo",
      objective: "Bajar de Peso",
      weeks: "1 Semana",
    },
    {
      id: 3,
      name: "Plan de Pollo",
      objective: "Bajar de Peso",
      weeks: "1 Semana",
    },
    {
      id: 4,
      name: "Plan de Pollo",
      objective: "Bajar de Peso",
      weeks: "1 Semana",
    },
    {
      id: 5,
      name: "Plan de Pollo",
      objective: "Bajar de Peso",
      weeks: "1 Semana",
    },
  ];

  //MODAL INFORMACION DE EJERCICIO
  const [openModalInfoExercise, setOpenModalInfoExercise] = useState(false);
  const handleOpenModalInfoExercise = () =>
    setOpenModalInfoExercise(!openModalInfoExercise);
  //FIN MODAL INFORMACION DE EJERCICIO

  //OPEN MODAL PLAN DE ENTRENAMIENTO DESCRIPCION
  const [openModalTrainingDescription, setOpenModalTrainingDescription] =
    useState(false);

  const handleOpenModalTrainingDescription = () =>
    setOpenModalTrainingDescription(!openModalTrainingDescription);
  //SELECT TABS DE MODAL
  const [selectedTabModalInfoTraining, setSelectedTabModalInfoTraining] =
    useState(1);
  const handleTabChangeTabModalInfoTraining = (tabId: any) => {
    setSelectedTabModalInfoTraining(tabId);
  };
  const tabsModalInfoTraining = [
    { id: 1, name: t("extra.controller.monday") },
    { id: 2, name: t("extra.controller.tuesday") },
    { id: 3, name: t("extra.controller.wednesday") },
    { id: 4, name: t("extra.controller.thursday") },
    { id: 5, name: t("extra.controller.friday") },
    { id: 6, name: t("extra.controller.saturday") },
    { id: 7, name: t("extra.controller.sunday") },
  ];

  const optionsTableInfoExercises = [
    {
      id: 1,
      name: "Jalón dorsal agarre ancho",
      image: "https://via.placeholder.com/150",
      series: "4",
      repetitions_time: "12",
      intensity: "70",
      break_seconds: "60",
      super_serie: false,
    },
    {
      id: 2,
      name: "Press de banca",
      image: "https://via.placeholder.com/150",
      series: "3",
      repetitions_time: "10",
      intensity: "80",
      break_seconds: "90",
      super_serie: true,
    },
    {
      id: 3,
      name: "Sentadilla frontal",
      image: "https://via.placeholder.com/150",
      series: "5",
      repetitions_time: "8",
      intensity: "85",
      break_seconds: "120",
      super_serie: false,
    },
    {
      id: 4,
      name: "Curl de bíceps con barra",
      image: "https://via.placeholder.com/150",
      series: "4",
      repetitions_time: "15",
      intensity: "60",
      break_seconds: "45",
      super_serie: true,
    },
    {
      id: 5,
      name: "Elevación lateral de hombros",
      image: "https://via.placeholder.com/150",
      series: "3",
      repetitions_time: "12",
      intensity: "65",
      break_seconds: "60",
      super_serie: false,
    },
  ];

  const [optionsCountryApi, setOptionsCountryApi] = useState([]);

  const [openEquipmentExercise, setOpenEquipmentExercise] = useState("others");
  const handleOpenEquipmentExercise = (name: string) => {
    setOpenEquipmentExercise(name);
  };

  //TRAER PAISES PARA SELECT COUNTRIES
  const {
    data: countries,
    isLoading: isLoadingCountries,
    isError: isErrorCountries,
  } = useGetAllCountriesQuery({});

  useEffect(() => {
    // Verifica que no esté cargando y que no haya errores
    if (!isLoadingCountries && !isErrorCountries && countries?.length > 0) {
      // Mapea y transforma los datos de los países
      console.debug(countries);
      const arrayCountries = countries.map((country) => ({
        id: country.name.common,
        name: country.name.common,
        code: country.cca2,
      }));

      // Actualiza el estado con los países formateados
      setOptionsCountryApi(arrayCountries);
    }

    // Manejamos los errores
    if (isErrorCountries) {
      console.log("ERROR EN LOS COUNTRIES");
    }
  }, [countries, isLoadingCountries, isErrorCountries]);

  const [lesson, setLesson] = useState({
    id: "",
    name: "",
    date: "",
  });

  const [enrollLesson, enrollLessonResuolt] = useEnrollLessonMutation();
  useEffect(() => {
    if (enrollLessonResuolt) {
      if (enrollLessonResuolt.isSuccess) {
        if (enrollLessonResuolt.data.data) {
          toasts.success(
            "Usuario inscrito",
            "El usuario ha sido inscrito correctamente"
          );
          setOpenDialogAsingLessons(!openDialogAsingLessons);
          return;
        }

        if (enrollAssistedResuolt.data.error) {
          toasts.danger(
            "Error al inscribir usuario",
            enrollAssistedResuolt.data.error
          );
        } else {
          toasts.success(
            "Usuario inscrito",
            "El usuario ha sido inscrito correctamente"
          );
        }

        setOpenDialogAsingLessons(!openDialogAsingLessons);
      }

      if (enrollLessonResuolt.isError) {
        toasts.danger(
          "Error al inscribir usuario",
          "Ha ocurrido un error al inscribir al usuario"
        );
        setOpenDialogAsingLessons(!openDialogAsingLessons);
      }
    }
  }, [enrollLessonResuolt]);

  const [enrollAssisted, enrollAssistedResuolt] = useEnrollAssistedMutation();
  useEffect(() => {
    if (enrollAssistedResuolt) {
      if (enrollAssistedResuolt.isSuccess) {
        if (enrollAssistedResuolt.data.error) {
          toasts.danger(
            "Error al inscribir usuario",
            enrollAssistedResuolt.data.error
          );
        } else {
          toasts.success(
            "Usuario inscrito",
            "El usuario ha sido inscrito correctamente"
          );
        }
        setOpenDialogAsingAssisteds(!openDialogAsingAssisteds);
      }

      if (enrollAssistedResuolt.isError) {
        toasts.danger(
          "Error al inscribir usuario",
          "Ha ocurrido un error al inscribir al usuario"
        );
        setOpenDialogAsingAssisteds(!openDialogAsingAssisteds);
      }
    }
  }, [enrollAssistedResuolt]);

  return (
    <>
      <UserContent
        OptionsBrandedActiveSP={OptionsBrandedActiveSP}
        handleOpenDialogAssingBond={handleOpenDialogAssingBond}
        handleOpenDialogEditBond={handleOpenDialogEditBond}
        OptionsBrandedActiveFeeCursos={OptionsBrandedActiveFeeCursos}
        setFormsCourses={setFormsCourses}
        handleOpenDialogCourses={handleOpenDialogCourses}
        setTitleDialogMethodsPay={setTitleDialogMethodsPay}
        handleOpenDialogAsingAssisteds={handleOpenDialogAsingAssisteds}
        handleOpenDialogAsingLessons={handleOpenDialogAsingLessons}
      />

      {/* Dialog Assgined Fee */}
      <DialogAssignFee
        open={openDialogAsingFee}
        setOpen={setOpenDialogAsingFee}
        openDialog={() => handleOpenDialogAsingFee}
        formSelect={formSelect}
        textButtonSubmit={t("bond.views.assign")}
        titleDialog={t("fees.views.assign_fee_user")}
      />

      <Modal
        open={openDialogAsingLessons}
        Close={() => setOpenDialogAsingLessons(!openDialogAsingLessons)}
        onClickCreate={() => {
          enrollLesson({
            branchId: user?.branch?.id,
            lessonId: lesson.id,
            userId: id,
          });
        }}
        textButtonCreate={t("general.accept")}
        textButtonClose={t("general.cancel")}
        tittleModal={t("branch.views.info")}
        disabledCreated={enrollLessonResuolt.isLoading}
      >
        <form>
          <div className="gap-4">
            <div className="col-span-full mt-5">
              {enrollLessonResuolt.isLoading ? (
                <div className="flex flex-1 flex-col items-center justify-center">
                  <div
                    className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] text-primary motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-primary"
                    role="status"
                  >
                    <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                      Loading...
                    </span>
                  </div>
                </div>
              ) : (
                <p className="text-sm text-gray-500 px-4">
                  {t("share.views.msg_enroll", {
                    lesson: lesson.name,
                    date: lesson.date,
                  })}
                </p>
              )}
            </div>
          </div>
        </form>
      </Modal>

      <Modal
        open={openDialogAsingAssisteds}
        Close={() => setOpenDialogAsingAssisteds(!openDialogAsingAssisteds)}
        onClickCreate={() => {
          enrollAssisted({
            branchId: user?.branch?.id,
            assistedId: lesson.id,
            userId: id,
          });
        }}
        textButtonCreate={t("general.accept")}
        textButtonClose={t("general.cancel")}
        tittleModal={t("branch.views.info")}
        disabledCreated={enrollAssistedResuolt.isLoading}
      >
        <form>
          <div className="gap-4">
            <div className="col-span-full mt-5">
              {enrollAssistedResuolt.isLoading ? (
                <div className="flex flex-1 flex-col items-center justify-center">
                  <div
                    className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] text-primary motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-primary"
                    role="status"
                  >
                    <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                      Loading...
                    </span>
                  </div>
                </div>
              ) : (
                <p className="text-sm text-gray-500 px-4">
                  {t("share.views.msg_enroll", {
                    lesson: lesson.name,
                    date: lesson.date,
                  })}
                </p>
              )}
            </div>
          </div>
        </form>
      </Modal>

      {/*
      <DialogCreate
        open={openDialogAsingAssisteds}
        setOpen={setOpenDialogAsingAssisteds}
        tittle={t("assisted.views.enroll_modal_title")}
        tittleButtonCreate={t("user.views.confirm")}
        tittleButtonCancel={t("general.cancel")}
        OnclickCreate={handleSubmit}
        OnclickCancel={handleOpenDialogAsingAssisteds}
      >
        <div className="mt-6 mx-2">
          <div className="space-y-12">
            <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200">
              <div className="flex items-center justify-center h-full text-center">
                <div>
                  <h2 className="text-base font-semibold leading-7 text-gray-900">
                    {t("fees.views.select_method")}
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DialogCreate>
      */}

      {/*
      <DialogCreate
        open={openDialogAsingFee}
        setOpen={setOpenDialogAsingFee}
        tittle={t("fees.views.assign_fee_user")}
        tittleButtonCreate={t("bond.views.assign")}
        tittleButtonCancel={t("general.cancel")}
        OnclickCreate={() => {}}
        OnclickCancel={handleOpenDialogAsingFee}
      >
        <div className="mt-6 mx-2">
          <div className="space-y-12">
            <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200">
              <div className="flex items-center justify-center h-full text-center">
                <div>
                  <h2 className="text-base font-semibold leading-7 text-gray-900">
                    {t("user.views.info_assign_fee")}
                  </h2>
                </div>
              </div>
              <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                <div className="col-span-full">
                  <Select
                    name="fee"
                    tittle={t("customer-to-gym-subscription.views.motive_up")}
                    selected={motivoAlta}
                    setSelected={setMotivoAlta}
                    options={optionsMotivoAlta}
                  />
                </div>
                <div className="col-span-full">
                  <Select
                    name="matricula"
                    tittle={t(
                      "customer-to-gym-subscription.views.registration"
                    )}
                    selected={matricula}
                    setSelected={setMatricula}
                    options={optionsMatricula}
                  />
                </div>
                <div className="col-span-full">
                  <InputWithCornerHint
                    type="date"
                    label={t("user.views.date_renovation")}
                  />
                </div>
                <div className="col-span-full">
                  <Select
                    name=""
                    tittle={t("direct_debit.views.text_payment_title")}
                    selected={rangePays}
                    setSelected={setRangePays}
                    options={optionsRangePays}
                  />
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200">
              <div className="flex items-center justify-center h-full text-center">
                <div>
                  <h2 className="text-base font-semibold leading-7 text-gray-900">
                    {t("accounting.views.payment_method")}
                  </h2>
                </div>
              </div>
              <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                <div className="col-span-full">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 px-10">
                    <div className="flex items-center justify-center">
                      <InputRadio
                        name="option"
                        id="card"
                        value="card"
                        checked={selectedOption === "card"}
                        onChange={handleRadioChange}
                      />
                      <label
                        htmlFor="card"
                        className="ml-3 block text-sm font-medium text-gray-700"
                      >
                        {t("accounting.views.card")}
                      </label>
                    </div>

                    <div className="flex items-center justify-center">
                      <InputRadio
                        name="option"
                        id="payment_direct_debit"
                        value="payment_direct_debit"
                        checked={selectedOption === "payment_direct_debit"}
                        onChange={handleRadioChange}
                      />
                      <label
                        htmlFor="payment_direct_debit"
                        className="ml-3 block text-sm font-medium text-gray-700"
                      >
                        {t("fees.views.payment_direct_debit")}
                      </label>
                    </div>

                    <div className="flex items-center justify-center">
                      <InputRadio
                        name="option"
                        id="payment_cash"
                        value="payment_cash"
                        checked={selectedOption === "payment_cash"}
                        onChange={handleRadioChange}
                      />
                      <label
                        htmlFor="payment_cash"
                        className="ml-3 block text-sm font-medium text-gray-700"
                      >
                        {t("fees.views.payment_cash")}
                      </label>
                    </div>

                    <div className="flex items-center justify-center">
                      <InputRadio
                        name="option"
                        id="payment_direct_debit_manual"
                        value="payment_direct_debit_manual"
                        checked={
                          selectedOption === "payment_direct_debit_manual"
                        }
                        onChange={handleRadioChange}
                      />
                      <label
                        htmlFor="payment_direct_debit_manual"
                        className="ml-3 block text-sm font-medium text-gray-700"
                      >
                        {t("fees.views.payment_direct_debit_manual")}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-x-8 gap-y-10 md:grid-cols-3">
              <div className="flex items-center justify-center h-full text-center">
                <div>
                  <h2 className="text-base font-semibold leading-7 text-gray-900">
                    {t("user.views.info_payment_cash")}
                  </h2>
                </div>
              </div>
              <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2 pb-12">
                {selectedOption === "card" && (
                  <>
                    <div className="col-span-full">
                      <InputWithCornerHint label={t("user.views.name")} />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("subscription.views.billing_email")}
                      />
                    </div>
                    <div className="col-span-full">
                      <Select
                        selected={selectPais}
                        setSelected={setSelectPais}
                        options={optionsPais}
                        tittle={t("user.views.country")}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint label={t("user.views.address")} />
                    </div>
                    <div className="col-span-full">
                      <InputsCard
                        tittle={t("accounting.views.card")}
                        idInputTop={"card"}
                        nameInputTop={"card"}
                        placeholderInputTop={t("fees.views.card_number")}
                        idInputLeft={"dateExpires"}
                        nameInputLeft={"dateExpires"}
                        placeholderInputLeft={"MM/AA"}
                        idInputRight={"cvc"}
                        nameInputRight={"cvc"}
                        placeholderInputRight={"CVC"}
                      />
                    </div>
                  </>
                )}
                {selectedOption === "payment_cash" && (
                  <>
                    <div className="col-span-full">
                      <Select
                        selected={selectTypePayment}
                        setSelected={setSelectTypePayment}
                        options={optionsTypePayment}
                        tittle={t("direct_debit.views.payment_manual_message")}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("user.views.comments_code")}
                        type="text"
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("user.views.mount_payment")}
                        type="number"
                      />
                    </div>
                    <div className="col-span-full">
                      <label
                        htmlFor=""
                        className="block text-sm font-medium leading-6 text-gray-600"
                      >
                        {t("direct_debit.views.text_payment_select_5")}
                      </label>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-5">
                        <div className="flex items-center justify-center">
                          <InputRadio name="optionFee" id="proportional" />
                          <label
                            htmlFor="card"
                            className="ml-3 block text-sm font-medium text-gray-700"
                          >
                            {`${t(
                              "direct_debit.views.payment_proportional"
                            )} (87.1 eur)`}
                          </label>
                        </div>

                        <div className="flex items-center justify-center">
                          <InputRadio name="optionFee" id="complete" />
                          <label
                            htmlFor="payment_direct_debit"
                            className="ml-3 block text-sm font-medium text-gray-700"
                          >
                            {`${t(
                              "direct_debit.views.payment_complete"
                            )} (100 eur)`}
                          </label>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {selectedOption === "payment_direct_debit" && (
                  <>
                    <div className="col-span-full">
                      <InputWithCornerHint label={t("user.views.name")} />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("subscription.views.billing_email")}
                      />
                    </div>
                    <div className="col-span-full">
                      <Select
                        name="country"
                        selected={selectPais}
                        setSelected={setSelectPais}
                        options={optionsPais}
                        tittle={t("user.views.country")}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint label={t("user.views.address")} />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint label={t("user.views.IBAN")} />
                    </div>
                  </>
                )}
                {selectedOption === "payment_direct_debit_manual" && (
                  <>
                    <div className="col-span-full">
                      <InputWithCornerHint label={t("user.views.name")} />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("subscription.views.billing_email")}
                      />
                    </div>
                    <div className="col-span-full">
                      <Select
                        selected={selectPais}
                        setSelected={setSelectPais}
                        options={optionsPais}
                        tittle={t("user.views.country")}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint label={t("user.views.address")} />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint label={t("user.views.IBAN")} />
                    </div>
                  </>
                )}
              </div>
            </div>
            {selectedOption === "payment_cash" && (
              <div className="grid grid-cols-1 gap-x-8 gap-y-10 md:grid-cols-3 border-t border-gray-200 pt-12">
                <div className="flex items-center justify-center h-full text-center">
                  <div>
                    <h2 className="text-base font-semibold leading-7 text-gray-900">
                      {t("branch.views.tax_authorities")}
                    </h2>
                  </div>
                </div>
                <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2 pb-12">
                  <div className="col-span-full">
                    <Select
                      selected={selectHacienda}
                      setSelected={setSelectHacienda}
                      options={optionsHacienda}
                      tittle={t("gti.views.generate_in_treasury")}
                    />
                  </div>
                  {selectHacienda.id === 2 || selectHacienda.id === 3 ? (
                    <>
                      <div className="col-span-full">
                        <Select
                          tittle={t("gti.views.type_dni")}
                          selected={selectTypeId}
                          setSelected={setSelectTypeId}
                          options={optionsTypeId}
                        />
                      </div>
                      <div className="col-span-full">
                        <InputWithCornerHint
                          label={t("gti.views.nro_dni")}
                          type="number"
                        />
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            )}
          </div>
          {selectedOption === "payment_direct_debit_manual" && (
            <div className="pb-11">
              <p className="text-sm text-gray-500 text-center px-20">
                {t("user.views.description_direct_debit_manual")}
              </p>
            </div>
          )}
          {selectedOption === "payment_direct_debit" && (
            <div className="col-span-full pb-11">
              <p className="text-sm text-gray-500 text-center px-20">
                {t("user.views.description_direct_debit")}
              </p>
            </div>
          )}
        </div>
      </DialogCreate>
      */}

      <DialogCreate
        open={openDialogAssingBond}
        setOpen={setOpenDialogAssingBond}
        tittle={t("bond.views.want_to_assign_bond")}
        tittleButtonCreate={t("bond.views.assign")}
        tittleButtonCancel={t("general.cancel")}
        OnclickCreate={() => {}}
        OnclickCancel={handleOpenDialogAssingBond}
      >
        <div className="mt-6 mx-2">
          <div className="space-y-12">
            <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200">
              <div className="flex items-center justify-center h-full text-center">
                <div>
                  <h2 className="text-base font-semibold leading-7 text-gray-900">
                    {t("accounting.views.payment_method")}
                  </h2>
                </div>
              </div>
              <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                <div className="col-span-full">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 px-10">
                    {/* InputRadio 1 */}
                    <div className="flex items-center justify-center">
                      <InputRadio
                        name="optionBond"
                        id="cash"
                        value="cash"
                        checked={selectedOptionBond === "cash"}
                        onChange={handleRadioChangeBond}
                      />
                      <label
                        htmlFor="cash"
                        className="ml-3 block text-sm font-medium text-gray-700"
                      >
                        {t("accounting.views.manual")}
                      </label>
                    </div>
                    {/* InputRadio 4 */}

                    {userInfo &&
                    userInfo.branch &&
                    userInfo.branch.directDebitModule &&
                    userInfo.branch.gateway != "wompi" ? (
                      <div className="flex items-center justify-center">
                        <InputRadio
                          name="optionBond"
                          id="direct_debit"
                          value="direct_debit"
                          checked={selectedOptionBond === "direct_debit"}
                          onChange={handleRadioChangeBond}
                        />
                        <label
                          htmlFor="direct_debit"
                          className="ml-3 block text-sm font-medium text-gray-700"
                        >
                          {t("fees.views.payment_direct_debit")}
                        </label>
                      </div>
                    ) : null}

                    {/* InputRadio 2 */}
                    <div className="flex items-center justify-center">
                      <InputRadio
                        name="optionBond"
                        id="free"
                        value="free"
                        checked={selectedOptionBond === "free"}
                        onChange={handleRadioChangeBond}
                      />
                      <label
                        htmlFor="free"
                        className="ml-3 block text-sm font-medium text-gray-700"
                      >
                        {t("user.views.free")}
                      </label>
                    </div>

                    {/* InputRadio 3  

                      * Verificar si se necesita este input radio
                      
                    <div className="flex items-center justify-center">
                      <InputRadio
                        name="optionBond"
                        id="payment_direct_debit_manual"
                        value="payment_direct_debit_manual"
                        checked={
                          selectedOptionBond === "payment_direct_debit_manual"
                        }
                        onChange={handleRadioChangeBond}
                      />
                      <label
                        htmlFor="payment_direct_debit_manual"
                        className="ml-3 block text-sm font-medium text-gray-700"
                      >
                        {t("branch.views.direct_debit")}
                      </label>
                    </div>
                    */}
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-x-8 gap-y-10 md:grid-cols-3">
              <div className="flex items-center justify-center h-full text-center">
                <div>
                  <h2 className="text-base font-semibold leading-7 text-gray-900">
                    {t("user.views.info_payment_cash")}
                  </h2>
                </div>
              </div>
              <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                {selectedOptionBond === "cash" && (
                  <>
                    <div className="col-span-full">
                      <Select
                        selected={selectTypePayment}
                        setSelected={setSelectTypePayment}
                        options={optionsTypePayment}
                        tittle={t("direct_debit.views.payment_manual_message")}
                        textDescribe={t("user.views.confirm_manual")}
                      />
                    </div>
                  </>
                )}
                {selectedOptionBond === "free" && (
                  <>
                    <div className="col-span-full">
                      <p className="text-md text-gray-500">
                        ¿Está seguro que deseas asignarlo gratis? Esta acción es
                        irreversible.
                      </p>
                    </div>
                  </>
                )}
                {selectedOptionBond === "payment_direct_debit_manual" && (
                  <>
                    <div className="col-span-full">
                      <InputWithCornerHint label={t("user.views.name")} />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("subscription.views.billing_email")}
                      />
                    </div>
                    <div className="col-span-full">
                      <Select
                        selected={selectPais}
                        setSelected={setSelectPais}
                        options={optionsPais}
                        tittle={t("user.views.country")}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint label={t("user.views.address")} />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint label={t("user.views.IBAN")} />
                    </div>
                  </>
                )}
                {selectedOptionBond === "direct_debit" && (
                  <>
                    <>
                      <div className="col-span-full">
                        <InputWithCornerHint label={t("user.views.name")} />
                      </div>
                      <div className="col-span-full">
                        <InputWithCornerHint
                          label={t("subscription.views.billing_email")}
                        />
                      </div>
                      <div className="col-span-full">
                        <Select
                          selected={selectPais}
                          setSelected={setSelectPais}
                          options={optionsPais}
                          tittle={t("user.views.country")}
                        />
                      </div>
                      <div className="col-span-full">
                        <InputWithCornerHint label={t("user.views.address")} />
                      </div>
                      <div className="col-span-full">
                        <InputWithCornerHint label={t("user.views.IBAN")} />
                      </div>
                    </>
                  </>
                )}
              </div>
            </div>
            {(selectedOptionBond === "cash" ||
              selectedOptionBond === "free") && (
              <>
                <div className="grid grid-cols-1 gap-x-8 gap-y-10 md:grid-cols-3 border-t border-gray-200 pt-12">
                  <div className="flex items-center justify-center h-full text-center">
                    <div>
                      <h2 className="text-base font-semibold leading-7 text-gray-900">
                        {t("branch.views.tax_authorities")}
                      </h2>
                    </div>
                  </div>
                  <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2 pb-12">
                    <div className="col-span-full">
                      <Select
                        selected={selectHacienda}
                        setSelected={setSelectHacienda}
                        options={optionsHacienda}
                        tittle={t("gti.views.generate_in_treasury")}
                      />
                    </div>
                    {selectHacienda.id === 2 || selectHacienda.id === 3 ? (
                      <>
                        <div className="col-span-full">
                          <Select
                            tittle={t("gti.views.type_dni")}
                            selected={selectTypeId}
                            setSelected={setSelectTypeId}
                            options={optionsTypeId}
                          />
                        </div>
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("gti.views.nro_dni")}
                            type="number"
                          />
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
          {selectedOptionBond === "payment_direct_debit_manual" && (
            <div className="col-span-full pb-11 pt-11">
              <p className="text-sm text-gray-500 text-center px-20">
                {t("user.views.description_direct_debit_manual")}
              </p>
            </div>
          )}
          {selectedOptionBond === "direct_debit" && (
            <div className="col-span-full pb-11 pt-11">
              <p className="text-sm text-gray-500 text-center px-20">
                {t("user.views.description_direct_debit")}
              </p>
            </div>
          )}
        </div>
      </DialogCreate>

      <DialogCreate
        open={openDialogEditBond}
        setOpen={setOpenDialogEditBond}
        tittle={t("user.views.update_bond_user")}
        tittleButtonCreate={t("general.save")}
        tittleButtonCancel={t("general.cancel")}
        OnclickCreate={() => {}}
        OnclickCancel={handleOpenDialogEditBond}
      >
        <div className="mt-6 mx-2">
          <div className="space-y-12">
            <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
              <div className="flex items-center justify-center h-full text-center">
                <div>
                  <h2 className="text-base font-semibold leading-7 text-gray-900">
                    {t("user.views.info_sessions")}
                  </h2>
                </div>
              </div>
              <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                <div className="col-span-full">
                  <InputWithCornerHint
                    label={t("user.views.new_quantity_sessiones")}
                    id=""
                    name=""
                    type="text"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </DialogCreate>

      <DialogCreate
        open={openDialogCourses}
        setOpen={setOpenDialogCourses}
        tittle={t("course.views.courses")}
        tittleButtonCreate={t("user.views.confirm")}
        tittleButtonCancel={t("general.cancel")}
        OnclickCreate={() => {}}
        OnclickCancel={handleOpenDialogCourses}
      >
        {formsCourses === 1 && (
          <div className="mt-6 mx-2">
            <div className="space-y-12">
              <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
                <div className="flex items-center justify-center h-full text-center">
                  <div>
                    <h2 className="text-base font-semibold leading-7 text-gray-900">
                      {t("course.views.enroll")}
                    </h2>
                  </div>
                </div>
                <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                  <div className="col-span-full">
                    <InputWithCornerHint
                      label={t("user.views.date_enroll")}
                      type="date"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {formsCourses === 2 && (
          <div className="mt-6 mx-2">
            <div className="space-y-12">
              <p className="px-10 text-center">
                {t("course.views.unsubscribe_text")}
              </p>
              <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
                <div className="flex items-center justify-center h-full text-center">
                  <div>
                    <h2 className="text-base font-semibold leading-7 text-gray-900">
                      {t("course.views.unsubscribe")}
                    </h2>
                  </div>
                </div>
                <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                  <div className="col-span-full">
                    <InputWithCornerHint
                      label={t("user.views.date_unsuscribe")}
                      type="date"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </DialogCreate>

      <DialogCreate
        open={openDialogBondsSP}
        setOpen={setOpenDialogBondsSP}
        tittle={titleDialogSP}
        tittleButtonCreate={textButtonSubmitSP}
        tittleButtonCancel={t("general.cancel")}
        OnclickCreate={() => {}}
        OnclickCancel={handleOpenDialogBondsSP}
      >
        {formSp === 1 && (
          <>
            <div className="mt-6 mx-2">
              <div className="space-y-12">
                <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
                  <div className="flex items-center justify-center h-full text-center">
                    <div>
                      <h2 className="text-base font-semibold leading-7 text-gray-900">
                        {t("chat.app.information")}
                      </h2>
                    </div>
                  </div>
                  <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("user.views.new_quantity_sessiones")}
                        type="number"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {formSp === 2 && (
          <div className="mt-6 mx-2">
            <div className="space-y-12">
              <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
                <div className="flex items-center justify-center h-full text-center">
                  <div>
                    <h2 className="text-base font-semibold leading-7 text-gray-900">
                      {t("chat.app.information")}
                    </h2>
                  </div>
                </div>
                <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                  <div className="col-span-full">
                    <InputWithCornerHint
                      label={t("user.views.search_user")}
                      type="text"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </DialogCreate>

      <DialogCreate
        open={openDialogFeeCursos}
        setOpen={setOpenDialogFeeCursos}
        tittle={titleDialogFeeCursos}
        tittleButtonCreate={t("general.accept")}
        tittleButtonCancel={t("general.cancel")}
        OnclickCreate={() => {}}
        OnclickCancel={handleOpenDialogFeeCursos}
      >
        {formFeeCursos === 1 && (
          <>
            <div className="mt-6 mx-2">
              <div className="space-y-12">
                <p className="px-10 text-center">
                  {t("fees.views.text_modal_confirm_low")}
                </p>
                <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
                  <div className="flex items-center justify-center h-full text-center">
                    <div>
                      <h2 className="text-base font-semibold leading-7 text-gray-900">
                        {t("chat.app.information")}
                      </h2>
                    </div>
                  </div>
                  <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                    <div className="col-span-full">
                      <Select
                        options={optionsBaja}
                        selected={selectedBaja}
                        setSelected={setSelectedBaja}
                        tittle={t(
                          "customer-to-gym-subscription.views.motive_down"
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {formFeeCursos === 2 && (
          <>
            <div className="mt-6 mx-2">
              <div className="space-y-12 mt-20">
                <p className="px-10 text-center">
                  {t("fees.views.description_cancel_fee")}
                </p>
              </div>
            </div>
          </>
        )}
        {formFeeCursos === 3 && (
          <>
            <div className="mt-6 mx-2">
              <div className="space-y-12 mt-20">
                <p className="px-10 text-center">
                  {t("fees.views.desactive_recurrency_text")}
                </p>
              </div>
            </div>
          </>
        )}
      </DialogCreate>

      <DialogCreate
        open={openDialogRenewFeeCR}
        setOpen={setOpenDialogRenewFeeCR}
        tittle={t("bond.views.paid")}
        tittleButtonCreate={t("bond.views.paid")}
        tittleButtonCancel={t("general.cancel")}
        OnclickCreate={() => {}}
        OnclickCancel={handleOpenDialogRenewFeeCR}
      >
        <div className="mt-6 mx-2">
          <div className="space-y-12">
            <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200">
              <div className="flex items-center justify-center h-full text-center">
                <div>
                  <h2 className="text-base font-semibold leading-7 text-gray-900">
                    {t("user.views.info_assign_fee")}
                  </h2>
                </div>
              </div>
              <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                <div className="col-span-full">
                  <Select
                    tittle={t(
                      "customer-to-gym-subscription.views.registration"
                    )}
                    selected={matricula}
                    setSelected={setMatricula}
                    options={optionsMatricula}
                  />
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200">
              <div className="flex items-center justify-center h-full text-center">
                <div>
                  <h2 className="text-base font-semibold leading-7 text-gray-900">
                    {t("accounting.views.payment_method")}
                  </h2>
                </div>
              </div>
              <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                <div className="col-span-full">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 px-10">
                    {/* InputRadio 1 */}
                    <div className="flex items-center justify-center">
                      <InputRadio
                        name="option"
                        id="card"
                        value="card"
                        checked={selectedOption === "card"}
                        onChange={handleRadioChange}
                      />
                      <label
                        htmlFor="card"
                        className="ml-3 block text-sm font-medium text-gray-700"
                      >
                        {t("accounting.views.card")}
                      </label>
                    </div>

                    {/* InputRadio 2 */}
                    <div className="flex items-center justify-center">
                      <InputRadio
                        name="option"
                        id="payment_direct_debit"
                        value="payment_direct_debit"
                        checked={selectedOption === "payment_direct_debit"}
                        onChange={handleRadioChange}
                      />
                      <label
                        htmlFor="payment_direct_debit"
                        className="ml-3 block text-sm font-medium text-gray-700"
                      >
                        {t("fees.views.payment_direct_debit")}
                      </label>
                    </div>

                    {/* InputRadio 3 */}
                    <div className="flex items-center justify-center">
                      <InputRadio
                        name="option"
                        id="payment_cash"
                        value="payment_cash"
                        checked={selectedOption === "payment_cash"}
                        onChange={handleRadioChange}
                      />
                      <label
                        htmlFor="payment_cash"
                        className="ml-3 block text-sm font-medium text-gray-700"
                      >
                        {t("fees.views.payment_cash")}
                      </label>
                    </div>

                    {/* InputRadio 4 */}
                    <div className="flex items-center justify-center">
                      <InputRadio
                        name="option"
                        id="payment_direct_debit_manual"
                        value="payment_direct_debit_manual"
                        checked={
                          selectedOption === "payment_direct_debit_manual"
                        }
                        onChange={handleRadioChange}
                      />
                      <label
                        htmlFor="payment_direct_debit_manual"
                        className="ml-3 block text-sm font-medium text-gray-700"
                      >
                        {t("fees.views.payment_direct_debit_manual")}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-x-8 gap-y-10 md:grid-cols-3">
              <div className="flex items-center justify-center h-full text-center">
                <div>
                  <h2 className="text-base font-semibold leading-7 text-gray-900">
                    {t("user.views.info_payment_cash")}
                  </h2>
                </div>
              </div>
              <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                {selectedOption === "card" && (
                  <>
                    <div className="col-span-full">
                      <InputWithCornerHint label={t("user.views.name")} />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("subscription.views.billing_email")}
                      />
                    </div>
                    <div className="col-span-full">
                      <Select
                        selected={selectPais}
                        setSelected={setSelectPais}
                        options={optionsPais}
                        tittle={t("user.views.country")}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint label={t("user.views.address")} />
                    </div>
                    <div className="col-span-full">
                      <InputsCard
                        tittle={t("accounting.views.card")}
                        idInputTop={"card"}
                        nameInputTop={"card"}
                        placeholderInputTop={t("fees.views.card_number")}
                        idInputLeft={"dateExpires"}
                        nameInputLeft={"dateExpires"}
                        placeholderInputLeft={"MM/AA"}
                        idInputRight={"cvc"}
                        nameInputRight={"cvc"}
                        placeholderInputRight={"CVC"}
                      />
                    </div>
                  </>
                )}
                {selectedOption === "payment_cash" && (
                  <>
                    <div className="col-span-full">
                      <Select
                        selected={selectTypePayment}
                        setSelected={setSelectTypePayment}
                        options={optionsTypePayment}
                        tittle={t("direct_debit.views.payment_manual_message")}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("user.views.comments_code")}
                        type="text"
                      />
                    </div>
                  </>
                )}
                {selectedOption === "payment_direct_debit" && (
                  <>
                    <div className="col-span-full">
                      <InputWithCornerHint label={t("user.views.name")} />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("subscription.views.billing_email")}
                      />
                    </div>
                    <div className="col-span-full">
                      <Select
                        selected={selectPais}
                        setSelected={setSelectPais}
                        options={optionsPais}
                        tittle={t("user.views.country")}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint label={t("user.views.address")} />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint label={t("user.views.IBAN")} />
                    </div>
                  </>
                )}
                {selectedOption === "payment_direct_debit_manual" && (
                  <>
                    <div className="col-span-full">
                      <InputWithCornerHint label={t("user.views.name")} />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("subscription.views.billing_email")}
                      />
                    </div>
                    <div className="col-span-full">
                      <Select
                        selected={selectPais}
                        setSelected={setSelectPais}
                        options={optionsPais}
                        tittle={t("user.views.country")}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint label={t("user.views.address")} />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint label={t("user.views.IBAN")} />
                    </div>
                  </>
                )}
              </div>
            </div>
            {selectedOption === "payment_cash" && (
              <div className="grid grid-cols-1 gap-x-8 gap-y-10 md:grid-cols-3 border-t border-gray-200 pt-12">
                <div className="flex items-center justify-center h-full text-center">
                  <div>
                    <h2 className="text-base font-semibold leading-7 text-gray-900">
                      {t("branch.views.tax_authorities")}
                    </h2>
                  </div>
                </div>
                <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2 pb-12">
                  <div className="col-span-full">
                    <Select
                      selected={selectHacienda}
                      setSelected={setSelectHacienda}
                      options={optionsHacienda}
                      tittle={t("gti.views.generate_in_treasury")}
                    />
                  </div>
                  {selectHacienda.id === 2 || selectHacienda.id === 3 ? (
                    <>
                      <div className="col-span-full">
                        <Select
                          tittle={t("gti.views.type_dni")}
                          selected={selectTypeId}
                          setSelected={setSelectTypeId}
                          options={optionsTypeId}
                        />
                      </div>
                      <div className="col-span-full">
                        <InputWithCornerHint
                          label={t("gti.views.nro_dni")}
                          type="number"
                        />
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            )}
          </div>
          {selectedOption === "payment_direct_debit_manual" && (
            <div className="pb-11">
              <p className="text-sm text-gray-500 text-center px-20">
                {t("user.views.description_direct_debit_manual")}
              </p>
            </div>
          )}
          {selectedOption === "payment_direct_debit" && (
            <div className="col-span-full pb-11">
              <p className="text-sm text-gray-500 text-center px-20">
                {t("user.views.description_direct_debit")}
              </p>
            </div>
          )}
        </div>
      </DialogCreate>

      <DialogCreate
        open={openMethodsPay}
        setOpen={setOpenMethodsPay}
        tittle={titleDialogMethodsPay}
        tittleButtonCancel={t("general.cancel")}
        OnclickCancel={handleOpenMethodsPay}
        tittleButtonCreate={t("general.create")}
        OnclickCreate={() => {}}
      >
        {optionsMethodsPay.length > 0 ? (
          <>
            <div className="mt-6 mx-2">
              <div className="space-y-12">
                <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
                  <div className="flex items-center justify-center h-full text-center">
                    <div>
                      <h2 className="text-base font-semibold leading-7 text-gray-900">
                        {t("branch.views.title_method_payment")}
                      </h2>
                    </div>
                  </div>
                  <div className="grid max-w-2xl grid-cols-1 gap-x-6 sm:grid-cols-6 md:col-span-2">
                    {optionsMethodsPay.map((option) => (
                      <div className="col-span-full">
                        <div className="bg-white" key={option.id}>
                          <div className="px-4 py-2">
                            <div className="rounded-md bg-gray-50  py-5 sm:flex sm:items-start sm:justify-between">
                              <h4 className="sr-only">{option.name}</h4>
                              <div className="sm:flex sm:items-start">
                                <div className="mt-3 sm:ml-4 sm:mt-0">
                                  <div className="text-sm font-medium text-gray-900">
                                    {option.name}
                                  </div>
                                  <div className="mt-1 text-sm text-gray-600 sm:flex sm:items-center">
                                    <div>{option.description}</div>
                                  </div>
                                </div>
                              </div>
                              <div className="mt-4 sm:ml-6 sm:mt-0 sm:flex-shrink-0">
                                <a
                                  onClick={() => {}}
                                  href="#"
                                  className="text-primary-600 hover:text-primary-900 ml-4 mr-4"
                                >
                                  {t("general.edit")}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="mt-6 mx-2">
              <div className="space-y-12">
                <p className="text-center">
                  {t("user.views.no_billing_description")}{" "}
                </p>
              </div>
            </div>
          </>
        )}
      </DialogCreate>

      <DialogCreate
        open={openNutritionFile}
        setOpen={setOpenNutritionFile}
        tittle={t("user.views.nutrition_file")}
        tittleButtonCancel={t("general.cancel")}
        OnclickCancel={handleOpenNutritionFile}
        tittleButtonCreate={t("general.create")}
        OnclickCreate={() => {}}
      >
        <div className="mt-6 mx-2">
          <div className="space-y-12">
            <p className="text-center">{t("user.views.nutrition_file_text")}</p>
            {archiveNutritionFile.length > 0 ? (
              <>
                <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 pt-10">
                  <div className="flex items-center justify-center h-full text-center">
                    <div>
                      <h2 className="text-base font-semibold leading-7 text-gray-900">
                        {t("user.views.medical_reports_uploaded")}
                      </h2>
                    </div>
                  </div>
                  <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                    <div className="col-span-full">
                      <div className="flex justify-between items-center p-4 rounded-md">
                        <p className="text-sm text-gray-700">
                          {t("user.views.nutrition_file_description")}
                        </p>

                        <div className="flex space-x-2">
                          <a
                            onClick={() => {}}
                            href="#"
                            className="text-primary-600 hover:text-primary-900 ml-4 mr-4"
                          >
                            {t("gym.views.see")}
                          </a>

                          <a
                            onClick={() => {}}
                            href="#"
                            className="text-red-600 hover:text-red-900 mr-4"
                          >
                            <FontAwesomeIcon icon={faTrashCan} />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
                  <div className="flex items-center justify-center h-full text-center">
                    <div>
                      <h2 className="text-base font-semibold leading-7 text-gray-900">
                        {t("user.views.subir_recomendacion")}
                      </h2>
                    </div>
                  </div>
                  <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                    <div className="col-span-full">
                      <InputFilepdf
                        name="pdf"
                        id="pdf"
                        label={t("user.views.recomendation_nutrition")}
                        span=""
                        spanButton={t("user.views.recomendation")}
                        description={t("general.format_pdf")}
                        selectedFileName={""}
                        error={false}
                        onFileChange={() => {}}
                        onRemoveFile={() => {}}
                        tittleDelete={t("general.delete_archive")}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </DialogCreate>

      <ModalPlans
        Close={handleOpenModalTrainingPlan}
        open={openModalTrainingPlan}
        textButtonClose={t("general.cancel")}
        tittleModal={t("user.views.workout_plan")}
      >
        <TableListPlan
          description={t("user.views.list_routines")}
          isLoading={false}
          OnDuplicate={() => {}}
          onAssing={() => {}}
          onEdit={() => {}}
          trainings={trainings}
        />
      </ModalPlans>

      <DialogCreate
        open={openNewPlanNutrition}
        setOpen={setOpenNewPlanNutrition}
        tittle={t("chat.app.nutrition_plan")}
        tittleButtonCancel={t("general.cancel")}
        OnclickCancel={handleOpenNewPlanNutrition}
        tittleButtonCreate={t("general.create")}
        OnclickCreate={() => {}}
      >
        <div className="mt-6 mx-2">
          <div className="space-y-12">
            <div className="grid grid-cols-1 gap-x-8 gap-y-10 md:grid-cols-3">
              <div className="flex items-center justify-center h-full text-center">
                <div>
                  <h2 className="text-base font-semibold leading-7 text-gray-900">
                    {t("accounting.views.actions")}
                  </h2>
                </div>
              </div>
              <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                <div className="col-span-full">
                  <ButtonFullSecondary
                    text={t("user.views.new_plan")}
                    size="extraLarge"
                  />
                </div>
                <div className="col-span-full">
                  <ButtonFullSecondary
                    text={t("user.views.duplicate_plan")}
                    size="extraLarge"
                  />
                </div>
                <div className="col-span-full">
                  <ButtonFullSecondary
                    text={t("user.views.edit_planned_plan")}
                    size="extraLarge"
                  />
                </div>
                <div className="col-span-full">
                  <ButtonFullSecondary
                    text={t("user.views.search_plan")}
                    size="extraLarge"
                    onClick={handleOpenModalNutritionPlan}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </DialogCreate>

      <ModalPlans
        Close={handleOpenModalNutritionPlan}
        open={openModalNutritionPlan}
        textButtonClose={t("general.cancel")}
        tittleModal={t("user.views.nutrition_plan")}
      >
        <TableListPlan
          description={t("user.views.list_nutrition")}
          isLoading={false}
          OnDuplicate={() => {}}
          onAssing={() => {}}
          onEdit={() => {}}
          trainings={nutritions}
        />
      </ModalPlans>

      <ModalDescriptionPlan
        Close={handleOpenModalTrainingDescription}
        open={openModalTrainingDescription}
        textButtonClose={t("general.cancel")}
        tittleModal={"Nombre del Plan"}
      >
        <div className="w-full h-full max-h-[80vh] overflow-y-auto px-5">
          <div className="mt-5">
            <TabsUser
              selectedTab={selectedTabModalInfoTraining}
              handleTabChange={handleTabChangeTabModalInfoTraining}
              tabs={tabsModalInfoTraining}
            />
          </div>

          {selectedTabModalInfoTraining === 1 && (
            <>
              <TableListExercisesWeekDescription
                title={"Calentamiento"}
                exercises={optionsTableInfoExercises}
                isLoading={false}
                onClickViewExercise={handleOpenModalInfoExercise}
                duration={"5"}
              />
              <div className="border-b border-gray-300 mt-5"></div>
              <TableListExercisesWeekDescription
                title={"Principal"}
                exercises={optionsTableInfoExercises}
                isLoading={false}
                onClickViewExercise={handleOpenModalInfoExercise}
                duration={"5"}
              />
              <div className="border-b border-gray-300 mt-5"></div>
              <TableListExercisesWeekDescription
                title={"Vuelta a la calma"}
                exercises={optionsTableInfoExercises}
                isLoading={false}
                onClickViewExercise={handleOpenModalInfoExercise}
                duration={"5"}
              />
            </>
          )}
          {selectedTabModalInfoTraining === 2 && <>{t("days.tuesday")}</>}
          {selectedTabModalInfoTraining === 3 && <>{t("days.wednesday")}</>}
          {selectedTabModalInfoTraining === 4 && <>{t("days.thursday")}</>}
          {selectedTabModalInfoTraining === 5 && <>{t("days.friday")}</>}
          {selectedTabModalInfoTraining === 6 && <>{t("days.saturday")}</>}
          {selectedTabModalInfoTraining === 7 && <>{t("days.sunday")}</>}
        </div>
      </ModalDescriptionPlan>

      <ModalDescriptionExercise
        Close={handleOpenModalInfoExercise}
        open={openModalInfoExercise}
        tittleModal={"Nombre del ejercicio"}
      >
        <div className="h-full max-h-[80vh] overflow-y-auto">
          <div className="flex justify-center">
            <video
              className="mb-3"
              src="/1.mp4"
              width="75%"
              height="300"
              controls
            ></video>
          </div>
          <h1 className="text-base font-semibold leading-6 text-gray-900 border-b border-gray-200 pb-3 mt-10">
            {t("share.views.description")}
          </h1>
          <ul role="list" className="space-y-6 mt-5">
            <li className="relative flex gap-x-4">
              <div className="h-6 absolute left-0 top-0 flex w-6 justify-center">
                <div className="w-px bg-gray-200" />
              </div>
              <div className="relative flex h-6 w-6 flex-none items-center justify-center bg-white">
                <div className="h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300 mt-1" />
              </div>
              <p className="flex-auto py-0.5 text-xs leading-5 text-gray-500">
                <span className="text-base text-gray-700">
                  Descripcion super larga de un ejercicio
                </span>
              </p>
            </li>
            <li className="relative flex gap-x-4">
              <div className="h-6 absolute left-0 top-0 flex w-6 justify-center">
                <div className="w-px bg-gray-200" />
              </div>
              <div className="relative flex h-6 w-6 flex-none items-center justify-center bg-white">
                <div className="h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300 mt-1" />
              </div>
              <p className="flex-auto py-0.5 text-xs leading-5 text-gray-500">
                <span className="text-base text-gray-700">
                  Descripcion super larga de un ejercicio
                </span>
              </p>
            </li>
            <li className="relative flex gap-x-4">
              <div className="h-6 absolute left-0 top-0 flex w-6 justify-center">
                <div className="w-px bg-gray-200" />
              </div>
              <div className="relative flex h-6 w-6 flex-none items-center justify-center bg-white">
                <div className="h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300 mt-1" />
              </div>
              <p className="flex-auto py-0.5 text-xs leading-5 text-gray-500">
                <span className="text-base text-gray-700">
                  Descripcion super larga de un ejercicio para ver que tal queda
                  en movil
                </span>
              </p>
            </li>
          </ul>
          {/* Aquí seguiría el resto del contenido */}
          <div className="grid grid-cols-2 gap-4 mt-5 px-5">
            {/* Sección de músculos */}
            <div className="">
              <h1 className="text-base font-semibold leading-6 text-gray-900 border-b border-gray-200 pb-3">
                {t("user.views.target_muscle")}
              </h1>
              {/* Lista de músculos */}
              <ul role="list" className="space-y-6 mt-5">
                <li className="relative flex gap-x-4">
                  <div className="h-6 absolute left-0 top-0 flex w-6 justify-center">
                    <div className="w-px bg-gray-200" />
                  </div>
                  <div className="relative flex h-6 w-6 flex-none items-center justify-center bg-white">
                    <div className="h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300 mt-1" />
                  </div>
                  <p className="flex-auto py-0.5 text-xs leading-5 text-gray-500">
                    <span className="text-base text-gray-700">Gluteos</span>
                  </p>
                </li>
              </ul>
            </div>
            <div className="">
              <h1 className="text-base font-semibold leading-6 text-gray-900 border-b border-gray-200 pb-3">
                {t("user.views.secound_muscle")}
              </h1>
              {/* Lista de músculos */}
              <ul role="list" className="space-y-6 mt-5">
                <li className="relative flex gap-x-4">
                  <div className="h-6 absolute left-0 top-0 flex w-6 justify-center">
                    <div className="w-px bg-gray-200" />
                  </div>
                  <div className="relative flex h-6 w-6 flex-none items-center justify-center bg-white">
                    <div className="h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300 mt-1" />
                  </div>
                  <p className="flex-auto py-0.5 text-xs leading-5 text-gray-500">
                    <span className="text-base text-gray-700">Triceps</span>
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <h1 className="text-base font-semibold leading-6 text-gray-900 border-b border-gray-200 pb-3 mt-10">
            {t("user.views.equipments")}
          </h1>
          <div className="flex flex-col items-center mt-6">
            {openEquipmentExercise === "straight_bar" && (
              <>
                <img
                  src="/ImagesEquipmentsExercesices/weight-lifting.png"
                  alt="weight-lifting.png"
                  className="w-28 h-28 object-cover"
                />
                <p className="text-center text-xl text-gray-900 mt-5 font-semibold">
                  {t("data.equipments.straight_bar")}
                </p>
              </>
            )}
            {openEquipmentExercise === "ez_bar" && (
              <>
                <img
                  src="/ImagesEquipmentsExercesices/ez-bar.png"
                  alt="ez-bar.png"
                  className="w-28 h-28 object-cover"
                />
                <p className="text-center text-xl text-gray-900 mt-5 font-semibold">
                  {t("data.equipments.ez_bar")}
                </p>
              </>
            )}
            {openEquipmentExercise === "dumbbells" && (
              <>
                <FontAwesomeIcon
                  icon={faDumbbell}
                  className="w-28 h-28 object-cover"
                />
                <p className="text-center text-xl text-gray-900 mt-5 font-semibold">
                  {t("data.equipments.dumbbells")}
                </p>
              </>
            )}
            {openEquipmentExercise === "bank" && (
              <>
                <img
                  src="/ImagesEquipmentsExercesices/bench.png"
                  alt="bench.png"
                  className="w-28 h-28 object-cover"
                />
                <p className="text-center text-xl text-gray-900 mt-5 font-semibold">
                  {t("data.equipments.bank")}
                </p>
              </>
            )}
            {openEquipmentExercise === "pulley" && (
              <>
                <img
                  src="/ImagesEquipmentsExercesices/pulley.png"
                  alt="pulley.png"
                  className="w-28 h-28 object-cover"
                />
                <p className="text-center text-xl text-gray-900 mt-5 font-semibold">
                  {t("data.equipments.pulley")}
                </p>
              </>
            )}
            {openEquipmentExercise === "tape" && (
              <>
                <img
                  src="/ImagesEquipmentsExercesices/tape.png"
                  alt="tape.png"
                  className="w-28 h-28 object-cover"
                />
                <p className="text-center text-xl text-gray-900 mt-5 font-semibold">
                  {t("data.equipments.tape")}
                </p>
              </>
            )}
            {openEquipmentExercise === "elastic_band" && (
              <>
                <img
                  src="/ImagesEquipmentsExercesices/elastic-band.png"
                  alt="elastic-band.png"
                  className="w-28 h-28 object-cover"
                />
                <p className="text-center text-xl text-gray-900 mt-5 font-semibold">
                  {t("data.equipments.elastic_band")}
                </p>
              </>
            )}
            {openEquipmentExercise === "lift_own_weight" && (
              <>
                <FontAwesomeIcon
                  icon={faPersonRays}
                  className="w-28 h-28 object-cover"
                />
                <p className="text-center text-xl text-gray-900 mt-5 font-semibold">
                  {t("data.equipments.lift_own_weight")}
                </p>
              </>
            )}
            {openEquipmentExercise === "others" && (
              <>
                <FontAwesomeIcon
                  icon={faCommand}
                  className="w-28 h-28 object-cover"
                />
                <p className="text-center text-xl text-gray-900 mt-5 font-semibold">
                  {t("data.equipments.others")}
                </p>
              </>
            )}
          </div>
        </div>
      </ModalDescriptionExercise>
    </>
  );
};
